import React from 'react';
import Link from 'next/link';
import { AssetProps } from '../../types';

interface ArticleBlogProps {
    blogContent?: {
        fields?: {
            className?: string;
            contentType?: string;
            ctaButton?: {
                fields?: {
                    contentType?: string;
                    ctaName?: string;
                    ctaUrl?: string;
                };
            };
            description?: string;
            image?: {
                fields?: {
                    classNames?: string;
                    contentType?: string;
                    desktopImage?: {
                        fields?: {
                            alternateText?: string;
                            asset?: AssetProps;
                        };
                    };
                    mobileImage?: {
                        fields?: {
                            alternateText?: string;
                            asset?: AssetProps;
                        };
                    };
                };
            };
        };
    };
    isMobile?: boolean;
}

const ArticleBlog: React.FC<ArticleBlogProps> = ({ blogContent, isMobile }) => {
    const { description, ctaButton, image } = blogContent?.fields || {};
    const { ctaName, ctaUrl } = ctaButton?.fields || {};
    const { mobileImage, desktopImage } = image?.fields || {};
    const { alternateText: mobileAltText, asset: mobileAsset } = mobileImage?.fields || {};
    const { alternateText: desktopAltText, asset: desktopAsset } = desktopImage?.fields || {};

    const imageUrl = isMobile
        ? mobileAsset?.fields?.file?.url
        : desktopAsset?.fields?.file?.url;

    const imageAltText = isMobile ? mobileAltText : desktopAltText;

    return (
        <div className='article-blog px-2 py-3 md:px-0 lg:pt-4 lg:pb-0 flex flex-col items-center relative w-full'>
            {imageUrl && (
                <img
                    src={`https:${imageUrl}`}
                    alt={imageAltText || ''}
                    width={isMobile ? 300 : 165}
                    height={isMobile ? 200 : 165}
                    className='w-full md:w-6/12 md:z-10'
                />
            )}
            <div className='absolute top-30per left-30per flex md:flex-col md:justify-center md:align-center md:relative md:left-0 md:top-9remLess md:h-full md:bg-revamp_bg md:rounded-2xl'>
                <div
                    className='font-regular xxs:text-10 text-11 md:text-base leading-tight md:leading-20 md:text-center text-revamp_white w-53per md:w-full md:px-2 md:pb-2 md:pt-12h'
                    dangerouslySetInnerHTML={{ __html: description || '' }}
                />
                {ctaName && ctaUrl && (
                    <Link
                        href={ctaUrl}
                        target="_blank"
                        className='article-blog-link flex justify-center items-center font-semi-bold z-10 text-10 md:text-lg pl-1h md:pl-0 md:pb-4'
                    >
                        {ctaName}
                    </Link>
                )}
            </div>
        </div>
    );
};

export default ArticleBlog;